"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const decodeSign = (value) => (value & 1 ? ~(value >>> 1) : (value >>> 1)); // eslint-disable-line no-bitwise,max-len
const decodeIntegers = (value, callback) => {
    let values = 0;
    let x = 0;
    let y = 0;
    let byte = 0;
    let current = 0;
    let bits = 0;
    for (let i = 0; i < value.length; i += 1) {
        byte = value.charCodeAt(i) - 63;
        current = current | ((byte & 0x1F) << bits); // eslint-disable-line no-bitwise,operator-assignment,max-len
        bits += 5;
        if (byte < 0x20) {
            if (++values & 1) { // eslint-disable-line no-plusplus,no-bitwise
                x = decodeSign(current);
            }
            else {
                y = decodeSign(current);
                callback(x, y);
            }
            current = 0;
            bits = 0;
        }
    }
    return values;
};
const googleMapsDecodePolylineString = (polyline) => {
    const PRECISION = 1e5;
    const points = [];
    let lat = 0;
    let lon = 0;
    decodeIntegers(polyline, (x, y) => {
        lat += x;
        lon += y;
        points.push({
            latitude: lat / PRECISION,
            longitude: lon / PRECISION,
        });
    });
    return points;
};
exports.default = googleMapsDecodePolylineString;
